import { getCollection } from '../../realm';
import { EMongoDbCollection, IMongodbEvent } from '../../types/mongodb';

export const logEventToMongodb = async (event: Partial<IMongodbEvent>) => {
  const collection = getCollection<IMongodbEvent>(EMongoDbCollection.events);
  collection
    .insertOne(event as IMongodbEvent)
    .catch(err => console.log(`Error in Logging Event: ${err}`));
};
